export const getSectionSeparatedData = (tabSeparatedData: any[]) => {
  const sections: any = {};

  // First, collect all fields by section
  tabSeparatedData.forEach((data) => {
    if (!sections[data.section]) {
      sections[data.section] = {
        fields: [],
        hasToggle: false, // Initialize hasToggle to false for each section
      };
    }
    sections[data.section].fields.push(data);

    // Check if this field is a section-level toggle
    if (data.fieldType === "Togglebox" && !data.parentFieldId) {
      sections[data.section].hasToggle = true;
    }
  });

  return sections;
};
